// extracted by mini-css-extract-plugin
module.exports = {"container":"BlogsByUser_container__175ns","Button":"BlogsByUser_Button__1Ygb8","Heading":"BlogsByUser_Heading__1eCBp"};